import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { BackgroundImage } from "@gik/ui-legacy/BackgroundImage";
import { HTMLParser } from "@gik/ui-legacy/HTMLParser";
import { KeepProportions } from "@gik/ui-legacy/KeepProportions";
import { FrameBone } from "@gik/ui-legacy/SkeletonLoader";
import type React from "react";

export type GiftTypeProps = {
	title?: string;
	imageUrl?: string;
	variant?: string;
	skeleton?: boolean;
} & UIComponent;

export const GiftTypeTileSkeleton = (): React.ReactElement => {
	const bem = bemBlock(`gift-type-tile-skeleton`);
	return (
		<div className={`${bem()}`}>
			<KeepProportions proportion={1}>
				<div className={bem("image-wrapper")}>
					<FrameBone className={bem("image")} />
				</div>
			</KeepProportions>
		</div>
	);
};

function GiftTypeTileComp({
	className,
	variant,
	title,
	imageUrl,
}: GiftTypeProps): React.ReactElement {
	const bem = bemBlock("gift-type-tile");

	if (!imageUrl) return <GiftTypeTileSkeleton />;

	return (
		<div className={bem(null, [{ [variant]: variant }], className)}>
			<KeepProportions proportion={1}>
				<BackgroundImage src={imageUrl} className={bem("box")}>
					<span className={bem("title")}>
						<HTMLParser rawHtml={title} />
					</span>
				</BackgroundImage>
			</KeepProportions>
		</div>
	);
}

export const GiftTypeTile = withComponentErrorBoundary(GiftTypeTileComp);
